import { BrowserRouter, Routes, Route } from "react-router-dom";
import { library } from '@fortawesome/fontawesome-svg-core';
  import { fab } from '@fortawesome/free-brands-svg-icons';
  import { faCheckSquare, faCoffee } from '@fortawesome/free-solid-svg-icons';
  import {faWhatsapp,faFacebook,faInstagram} from  '@fortawesome/free-brands-svg-icons'
import "./App.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import "../node_modules/jquery/dist/jquery.slim.min.js";
import "../node_modules/popper.js/dist/popper.min.js";
import "../node_modules/bootstrap/dist/js/bootstrap.min.js";
import HomepageModule from "./Page/HomepageModule";
import About from "./Page/AboutUsPage";
import DoctorLandingPage from "./Page/DoctorLandingPage.js";
import DoctorConsultationPage from "./Page/DoctorConsultationPage";
import TermsAndCondition from "./Page/Terms-and-Condition.js";
import ContactUs from "./Page/ContactUs.js";
import DoctorConsultationBookingPage from "./Page/doctorConsultationBookingPage.js";
import HospitalLandingPage from "./Page/hospital-pages/hospital-landingPage.js";
import HospitallistingPage from "./Page/hospital-pages/hospital-listingPage.js";
import MedicalTourism from "./Page/MedicalTourism/medicalTourism.js";
import Healthcardpage from "./Page/healthcardpage/healthcardpage.jsx";


function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<HomepageModule />}></Route>
          <Route exact path="/about" element={<About />}></Route>
          <Route exact path="/doctorlanding" element={<DoctorLandingPage />}></Route>
          <Route exact path="/doctorlanding/doctorDetail/:dept" element={<DoctorConsultationPage />}></Route>
          <Route exact path="/doctorBooking" element={<DoctorConsultationBookingPage />}></Route>
          <Route exact path="/terms&conditions" element={<TermsAndCondition />}></Route>
          <Route exact path="/hospitals" element={<HospitalLandingPage />}></Route>
          <Route exact path="/hospitals/associatedHospitals" element={<HospitallistingPage />}></Route>
          <Route exact path="/contactus" element={<ContactUs />}></Route>
          <Route exact path="/medicaltourism" element={<MedicalTourism />}></Route>
          <Route exact path="/healthcard" element={<Healthcardpage />}></Route>
        </Routes>
      </BrowserRouter>
      {/* <HomepageModule></HomepageModule> */}
    </>
  );
}

export default App;
library.add(fab,faWhatsapp,faFacebook,faInstagram)
